module.exports = __webpack_public_path__ + "static/media/zw.058f40fe.svg";